var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{attrs:{"title":(_vm.title ? _vm.title + ' — ' : '') + 'Tags',"height":"360px"}},[_c(_setup.Tag,{attrs:{"url":_vm.url,"write":_vm.write || undefined,"read":_vm.read || undefined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }